import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import toast from 'react-hot-toast';
import { ShoppingBagIcon, ArrowRightIcon } from '@heroicons/react/24/outline';

const SOCIALS = [
  {
    label: 'GitHub',
    href: 'https://github.com/sirojulanm',
    path: 'M12 2C6.48 2 2 6.58 2 12.26c0 4.5 2.87 8.32 6.84 9.67.5.1.68-.22.68-.48v-1.7c-2.78.62-3.37-1.37-3.37-1.37-.45-1.18-1.11-1.5-1.11-1.5-.9-.64.07-.62.07-.62 1 .07 1.53 1.06 1.53 1.06.9 1.57 2.34 1.12 2.91.86.09-.67.35-1.12.63-1.38-2.22-.26-4.56-1.14-4.56-5.06 0-1.12.39-2.03 1.03-2.75-.1-.26-.45-1.3.1-2.7 0 0 .84-.28 2.75 1.05a9.36 9.36 0 0 1 5 0c1.91-1.33 2.75-1.05 2.75-1.05.55 1.4.2 2.44.1 2.7.64.72 1.03 1.63 1.03 2.75 0 3.93-2.35 4.8-4.58 5.05.36.32.68.94.68 1.9v2.82c0 .27.18.59.69.48A10.14 10.14 0 0 0 22 12.26C22 6.58 17.52 2 12 2Z',
  },
  {
    label: 'LinkedIn',
    href: 'https://linkedin.com/in/sirojulanam',
    path: 'M6.94 8.5H3.56V20h3.38V8.5ZM5.25 3a1.97 1.97 0 1 0 0 3.94 1.97 1.97 0 0 0 0-3.94ZM20.44 20h-3.37v-5.99c0-1.5-.54-2.52-1.88-2.52-1.03 0-1.64.69-1.9 1.36-.1.24-.13.57-.13.9V20H9.8s.05-10.35 0-11.5h3.36v1.63c.45-.7 1.25-1.7 3.05-1.7 2.23 0 3.9 1.46 3.9 4.6V20Z',
  },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const year = new Date().getFullYear();

  const handleSubscribe = (event) => {
    event.preventDefault();
    if (!email.trim()) return;
    toast.success('Terima kasih! Kamu akan dapat info promo terbaru.');
    setEmail('');
  };

  return (
    <footer className="relative mt-20 overflow-hidden bg-slate-950 text-slate-400">
      <div className="pointer-events-none absolute -left-24 -top-24 h-64 w-64 rounded-full bg-brand-600/25 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 right-0 h-72 w-72 rounded-full bg-fuchsia-500/15 blur-3xl" />

      <div className="container-page relative py-14">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <NavLink to="/" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-brand-gradient text-white">
                <ShoppingBagIcon className="h-5 w-5" />
              </span>
              <span className="text-base font-extrabold text-white">Shopping Store</span>
            </NavLink>
            <p className="mt-4 max-w-sm text-sm leading-6">
              Lagi cari website e-commerce yang keren, modern, dan sesuai kebutuhan bisnis kamu?
              Website ini adalah salah satu contoh project e-commerce yang saya buat. Kalau kamu tertarik untuk
              punya website serupa atau punya ide website yang ingin diwujudkan, yuk, ngobrol bareng!
              Connect with me:
            </p>

            <div className="mt-5 flex items-center gap-2">
              {SOCIALS.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={social.label}
                  className="flex h-9 w-9 items-center justify-center rounded-xl bg-white/5 text-slate-300 transition hover:-translate-y-0.5 hover:bg-white/10 hover:text-white"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4">
                    <path d={social.path} />
                  </svg>
                </a>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-5">
            <div>
              <h3 className="text-xs font-bold uppercase tracking-widest text-slate-500">
                Jelajahi
              </h3>
              <ul className="mt-4 space-y-2.5 text-sm">
                <li><NavLink to="/" className="transition hover:text-white">Home</NavLink></li>
                <li><NavLink to="/icons" className="transition hover:text-white">Shop</NavLink></li>
                <li><NavLink to="/list" className="transition hover:text-white">Data Produk</NavLink></li>
              </ul>
            </div>
            <div>
              <h3 className="text-xs font-bold uppercase tracking-widest text-slate-500">
                Akun
              </h3>
              <ul className="mt-4 space-y-2.5 text-sm">
                <li><NavLink to="/login" className="transition hover:text-white">Sign in</NavLink></li>
                <li><NavLink to="/login" className="transition hover:text-white">Daftar</NavLink></li>
                <li><NavLink to="/login" className="transition hover:text-white">Lupa password</NavLink></li>
              </ul>
            </div>
            <div className="col-span-2 sm:col-span-1">
              <h3 className="text-xs font-bold uppercase tracking-widest text-slate-500">
                Sumber Data
              </h3>
              <ul className="mt-4 space-y-2.5 text-sm">
                <li>
                  <a
                    href="https://dummyjson.com"
                    target="_blank"
                    rel="noreferrer"
                    className="transition hover:text-white"
                  >
                    DummyJSON API
                  </a>
                </li>
                <li>
                  <a
                    href="https://tailwindcss.com"
                    target="_blank"
                    rel="noreferrer"
                    className="transition hover:text-white"
                  >
                    Tailwind CSS
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h3 className="text-xs font-bold uppercase tracking-widest text-slate-500">
              Newsletter
            </h3>
            <p className="mt-4 text-sm leading-6">
              Dapatkan promo dan produk baru langsung di inbox kamu.
            </p>
            <form onSubmit={handleSubscribe} className="mt-4">
              <div className="flex items-center gap-2 rounded-2xl border border-white/10 bg-white/5 p-1.5 focus-within:border-brand-400/60">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder="email@kamu.com"
                  aria-label="Alamat email"
                  className="min-w-0 flex-1 bg-transparent px-3 py-2 text-sm text-white placeholder:text-slate-500 focus:outline-none"
                />
                <button
                  type="submit"
                  aria-label="Berlangganan"
                  className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-brand-600 text-white transition hover:bg-brand-500"
                >
                  <ArrowRightIcon className="h-4 w-4" strokeWidth={2.5} />
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs sm:flex-row">
          <p>© {year} Shopping Store. All rights reserved.</p>
          <p>
            Made with <span className="text-rose-400">♥</span> using React & Tailwind
          </p>
        </div>
      </div>
    </footer>
  );
}
